import React, {useEffect, useState} from "react";
import { Helmet } from 'react-helmet';
import { request } from 'graphql-request';

import Hero from "./hero";
import CaseStudy from "../includes/caseStudy";

const portfolioBreadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://www.partneredmg.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Portfolio",
      "item": "https://www.partneredmg.com/portfolio"
    }
  ]
};

const portfolioPageSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "@id": "https://www.partneredmg.com/portfolio",
  "name": "Case Studies & Portfolio | Partnered Management Group",
  "description": "Real results from real clients. See how PMG's fractional project managers have helped businesses deliver projects on time and within budget.",
  "url": "https://www.partneredmg.com/portfolio",
  "provider": { "@id": "https://www.partneredmg.com/#organization" },
  "about": {
    "@type": "Service",
    "name": "Fractional Project Management",
    "provider": { "@id": "https://www.partneredmg.com/#organization" }
  }
};

const Portfolio = () => {
  const [caseStudies, setCaseStudy] = useState(null);
  const [isActive, setIsActive] = useState("0");
  const [loading, setLoading] = useState(true);

  const toggleCaseStudy = (id) => {
    if (isActive === id) {
        return setIsActive("0");
       }
       setIsActive(id);
  };

  useEffect(() => {
    const fetchCaseStudies = async () => {
      const {caseStudies} = await request(
        `https://us-east-1-shared-usea1-02.cdn.hygraph.com/content/${process.env.REACT_APP_CS_KEY}/master`,
        `
        {
          caseStudies {
            logoWhite {
              id
              url
            }
            logoBlack {
              id
              url
            }
            companyName
            backgroundCopy
            challengesCopy
            conclusionCopy
            resultsCopy
            solutionCopy
            statisticNumber1
            statisticText1
            statisticNumber2
            statisticText2
            statisticNumber3
            statisticText3
            id
          }
        }
    `
    );
      setCaseStudy(caseStudies);
      setLoading(false);
    }
    fetchCaseStudies();
  }, []);

  //console.log({caseStudies});  

    return (
        <div>
          <Helmet>
            <title>Case Studies & Portfolio | Fractional PM Results | PMG</title>
            <meta name="description" content="See how Partnered Management Group has helped businesses across industries improve project delivery, launch PMOs, and drive measurable results through fractional project management." />
            <link rel="canonical" href="https://www.partneredmg.com/portfolio" />
            <meta property="og:title" content="Case Studies | Fractional PM Results | PMG" />
            <meta property="og:description" content="Real results from real clients. See how PMG's fractional project managers have helped businesses deliver projects on time and within budget." />
            <meta property="og:url" content="https://www.partneredmg.com/portfolio" />
            <meta property="og:type" content="website" />
            <script type="application/ld+json">{JSON.stringify(portfolioPageSchema)}</script>
            <script type="application/ld+json">{JSON.stringify(portfolioBreadcrumbSchema)}</script>
          </Helmet>
          <Hero />
          <div className="w-full caseStudy-container">
          <h2 className={"pointer-events-none text-blue font-bold text-3xl" + (loading ? " block" : " hidden")}>Loading...</h2>
            {!loading && caseStudies.map((caseStudy, index) => (
                <CaseStudy caseStudy={caseStudy} key={caseStudy.id} index={index} onToggle={() => toggleCaseStudy(caseStudy.id)} active={isActive === caseStudy.id} isFeatured={false}/>
              ))}
          </div>
        </div>
    );
}

export default Portfolio;